import to from "await-to-js";
import { t } from "i18next";
import React, { useContext, useEffect } from "react";

import { Table } from "../../../../components/Table/Table";
import { ModalsContext } from "../../../../context/modals.context";
import { CentralRegistryContext } from "../../../../modules/ministry/centralRegistry/centralRegistry.context";
import { centralRegistryService } from "../../../../modules/ministry/centralRegistry/centralRegistry.service";
import style from "../CentralRegistry.module.scss";

interface ISubjectMerchantRegistryProps {
  type?: boolean;
}

export const SubjectMerchantRegistry: React.FC<
  ISubjectMerchantRegistryProps
> = ({ type }) => {
  //type is subject

  const { centralRegistry, setCentralRegistry } = useContext(
    CentralRegistryContext
  );
  const { setError } = useContext(ModalsContext);

  const handleApi = () => {
    if (type)
      return centralRegistryService.postPrivredniSubjektiPosebanPostupak();
    return centralRegistryService.postRegistarTrgovacaNaVeliko();
  };

  const postRegistarTrgovacaNaVeliko = async () => {
    const [err, res] = await to(handleApi());
    if (err || !res.success) return setError(res?.errorMessage);
    setCentralRegistry({ dynamicTable: res.data });
  };

  useEffect(() => {
    postRegistarTrgovacaNaVeliko();
  }, []);

  const colDef = [
    {
      title: t("TABLES.NAZIV_PRIVREDNOG_SUBJEKTA"),
      dataIndex: "naziv",
      width: "210px",
    },
    {
      title: t("TABLES.ADRESA_PRIVREDNOG_SUBJEKTA"),
      dataIndex: "adresa",
      width: "240px",
    },
    {
      title: t("COMMON.PIB"),
      dataIndex: "pib",
      width: "100px",
    },
    {
      title: t("TABLES.BROJ_RESENJA_O_UPISU_OBNOVE"),
      dataIndex: "brojResenjaOUpisu",
      width: "330px",
    },
    {
      title: t("TABLES.DATUM_OD_KADA_VAZI_DOZVOLA"),
      dataIndex: "datumVazenjaDozvoleOd",
      width: "230px",
    },
    ...(type
      ? [
          {
            title: t("AKCIZNE_MARKICE.OZNAKA_AKCIZNE_MARKICE"),
            dataIndex: "oznakaAkcizneMarkice",
            width: "210px",
          },
        ]
      : []),
  ];

  return (
    <div className={style.mainContainer}>
      <div id="subject_merchant_registry">
        <h2>
          {type
            ? t("NAVIGATION.REGISTAR_SUBJEKATA_CELO")
            : t("NAVIGATION.REGISTAR_TRGOVACA")}
        </h2>
      </div>
      <Table
        columns={colDef}
        scrollConfig={["#subject_merchant_registry"]}
        dataSource={centralRegistry.dynamicTable}
        name="subject-merchant-registry-table"
      />
    </div>
  );
};
